"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const redux_observable_1 = require("redux-observable");
const current_1 = require("./current");
const list_1 = require("./list");
const remark_1 = require("./remark");
const dashboard_1 = require("./dashboard");
const print_1 = require("./print");
const _folderList = require("../../modules/files/list/epics");
const imagesFolderList = _folderList.default('remark-images');
const confirmationImagesFolderList = _folderList.default('remark-confirmation-images');
exports.allEpics = redux_observable_1.combineEpics(
// Current
current_1.fetchMeterentry, current_1.handleCreateTRMVRMeterEntry, current_1.handleUpdateTRMVRMeterEntry, 
// Dashboard
dashboard_1.fetchOverviewEntries, dashboard_1.fetchPendingRemarks, 
// List
list_1.fetchMeterEntries, list_1.deleteMeterEntry, 
// Remarks
remark_1.fetchMeterEntryRemarks, remark_1.fetchMeterRemarks, remark_1.handleCreateTRMVRMeterEntryRemark, remark_1.fetchMeterEntryRemark, remark_1.handleUpdateMeterRemark, 
// Print
print_1.fetchTRMVRMeterEntriesToPrint, imagesFolderList.fetch, confirmationImagesFolderList.fetch);
//# sourceMappingURL=index.js.map